import { Component, forwardRef, Input, OnChanges, OnInit, SimpleChanges, signal } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALIDATORS, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { DropdownModule } from "primeng/dropdown";
import { CommonModule } from "@angular/common";
import { TranslateModule } from '@ngx-translate/core';
import { CustomFieldDTO } from 'src/app/DTO/CustomFieldDTO';
import { CustomFieldsConstants } from 'src/app/constants/CustomFieldsConstants';
import { AppCurrencyPipeModule } from 'src/app/pipes/CurrencyPipe/CurrencyPipe.pipe.module';

@Component({
  selector: 'app-custom-field-dropdown',
  standalone: true,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CustomFieldDropdownComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => CustomFieldDropdownComponent),
      multi: true
    }
  ],
  templateUrl: './dropdown.component.html',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DropdownModule,
    TranslateModule,
    AppCurrencyPipeModule
],
  styleUrls: ['../../styles/fields.scss']
})
export class CustomFieldDropdownComponent implements OnInit, OnChanges, ControlValueAccessor{

  @Input()
  public customField: CustomFieldDTO | null;
  @Input()
  public readonly: boolean;

  public isTable = false;
  public internalValue: any;
  public show = false;
  public DropdownTypes = CustomFieldsConstants.DropdownTypes;

  /** Opciones del desplegable; signal para que la vista se actualice al cambiar `dropdownOptions` o en `writeValue`. */
  readonly dropdownOptionsArrayShow = signal<string[]>([]);

  onChange: (_: string) => void = (_: string) => { };

  constructor() { }

  ngOnInit(): void {
    if (this.customField) {
      this.isTable = this.customField.dropdownType === 'TABLE';
    }
    this.syncDropdownOptionsArrayShow();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['customField']) {
      if (this.customField) {
        this.isTable = this.customField.dropdownType === 'TABLE';
      }
      this.syncDropdownOptionsArrayShow();
    }
  }

  private syncDropdownOptionsArrayShow(): void {
    if (!this.customField || this.isTable) {
      return;
    }
    const raw = this.customField.dropdownOptions ?? '';
    const next = raw.split('|');
    this.dropdownOptionsArrayShow.set(next);
    this.customField.dropdownOptionsArrayShow = next;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(): void { }

  writeValue(val: string): void {
    if (this.customField) {
      this.customField.value = val;

      if (!this.isTable) {
        this.syncDropdownOptionsArrayShow();
      }
    }

    this.internalValue = this.modelFromString(val);
  }

  validate() {
    return false;
  }

  updateChanges(value: string) {
    this.onChange(value);
  }

  private modelFromString(value: string): any {
    if (!value) { return null; }
    return value;
  }
}
